<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div class="form-content pt-4">
      <div class="row d-flex justify-content-between px-3">
        <h2 class="form-title-principal form-title">Reclamaciones</h2>
      </div>
      <div class="table-orders">
        <table class="table">
          <thead>
            <tr>
              <th style="max-width: 200px">Nombre</th>
              <th style="min-width: 180px">Tipo</th>
              <th>Tienda</th>
              <th>Fecha</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in reclamos" :key="data">
              <td style="max-width: 200px">{{ data.name }}</td>
              <td style="min-width: 180px">{{ data.type }}</td>
              <td>{{ data.store_id === 1?'SENDI':'ENVIOS USA' }}</td>
              <td>{{ data.created_at }}</td>
              <td>
                <router-link
                  :to="{ name: 'ReclamoDetails', params: { id: data.id } }"
                  class="link"
                  >Ver más</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination
      :pagination="pagination"
      @changePagination="getPurchaseOrdersByPage"
      v-if="is_loading == false"
    >
    </pagination>
  </div>
</template>
<style>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.link {
  color: #1f5ee7 !important;
  text-decoration: underline;
}

.user {
  font-weight: 600;
  margin: 0;
  padding: 0;
}
</style>
<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: { breadcrumb, Pagination },
  created() {},
  data() {
    return {
      reclamos: null,
      nameSection: "Reclamaciones",
      listRoutes: [{ nameRoute: "reclamaciones", titleRoute: "Reclamos de usuarios" }],
      tableData: {
        orderBy: "created_at",
        length: 10,
        page: 1,
      },

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      is_loading: true,
    };
  },
  created() {
    this.getPurchaseOrdersByPage();
  },
  methods: {
    getPurchaseOrdersByPage(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;

      let url = process.env.API_URL + "/api/view/reclamaciones";

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.reclamos = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Reclamaciones.vue?59eb3b19